import React from "react";

export default function AlertsIcon({ color }:{ color?: string; }) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0342 5.5C15.1013 5.50021 17.5877 7.98658 17.5879 11.0537V14.8223C17.5879 15.2395 17.7199 15.645 17.9629 15.9805L18.0742 16.1201L18.3545 16.4414C19.0553 17.2448 18.485 18.5 17.4189 18.5H6.87988C5.79884 18.5 5.18272 17.2649 5.83301 16.4014L6.08105 16.0713C6.3396 15.7278 6.47939 15.3098 6.47949 14.8799V11.0537C6.47968 7.98645 8.96688 5.5 12.0342 5.5Z"
          stroke={color ?? "var(--oda-color-1000)"}
        />
        <path
          d="M13 5.5V5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V5.5"
          stroke={color ?? "var(--oda-color-1000)"}
        />
        <path
          d="M14 18.5C14 19.6046 13.1046 20.5 12 20.5C10.8954 20.5 10 19.6046 10 18.5"
          stroke={color ?? "var(--oda-color-1000)"}
        />
      </svg>
    </>
  );
}
